<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <vs-tabs position="top" id="customer-profile-tabs" class="w-full">
        <vs-tab label="General">
          <ValidationObserver ref="form" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onClickSupplierProfileUpdate)" autocomplete="off">
              <vx-card class="mb-8" :title="form.status ? `Supplier Status: ${form.status.name}`  : ''" :titleColor="form.status.id === 3 ? 'primary' : 'warning'">
                <template slot="actions">
                  <div class="flex items-center">
                    <div class="flex items-center mr-4">
                      <small class="mr-2">Spray Dry Supplier</small>
                      <vs-switch v-model="form.is_spray_dry_supplier" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="w-16">
                        <span slot="on">Yes</span>
                        <span slot="off">No</span>
                      </vs-switch>
                    </div>
                    <div class="dropdown-button-container w-16" v-if="form.status">
                      <vs-dropdown>
                        <a class="flex items-center" href="#">
                          Status
                          <i class="material-icons"> expand_more </i>
                        </a>
                        <vs-dropdown-menu class="w-64">
                          <span v-for="(status, index) in status_list" :key="index">
                            <vs-dropdown-item
                              v-if="status.before_status.includes(form.status.id)"
                              @click="supplierStatusChangeConfirmDialog(status.value)"
                              :class="`text-${status.color}`">
                              {{ status.label }}
                            </vs-dropdown-item>
                          </span>
                        </vs-dropdown-menu>
                      </vs-dropdown>
                    </div>
                  </div>
                </template>
                <div class="vx-row mb-3 hidden">
                  <div class="vx-col w-full">
                    <div class="float-right mr-4">
                      <vs-chip class="float-right" transparent>
                        Supplier Status: <span class="font-bold">{{ form.status.name || 'N/A' }}</span>
                      </vs-chip>
                    </div>
                    <vs-chip class="float-right" transparent  v-if="form.is_supplier_activated === 1"  color="success">
                      Portal Status: Active
                    </vs-chip>
                    <vs-chip class="float-right" transparent  v-if="form.is_supplier_activated === 0"  color="danger">
                      Portal Status: Suspend
                    </vs-chip>
                  </div>
                </div>
                <div class="vx-row mb-3 mt-8">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="company_name" name="company_name" rules="required" v-slot="{ errors }">
                      <small class="label">Company Name</small>
                      <vs-input type="text" name="company_name" class="w-full" v-model="form.company_name"
                                :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="country" name="country" rules="required" v-slot="{ errors }">
                      <small class="label">Country</small>
                      <v-select :filter-by="myFilter" @input="selectCountry" :clearable="false" name="country" placeholder="" label="name" v-model="form.country" :reduce="option => option.name" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                        <template v-slot:option="option">
                          <span>{{option.name}} </span>
                        </template>
                      </v-select>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="l" name="l" rules="email" v-slot="{ errors }">
                      <small class="label">Email</small>
                      <vs-input type="text" name="email" class="w-full" v-model="form.l"
                                :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <div class="vx-row">
                      <div class="vx-col w-1/3">
                        <ValidationProvider vid="telephone_country_code" name="telephone_country_code" rules="required" v-slot="{ errors }">
                          <small class="label">Country Code</small>
                          <v-select :filter-by="myFilter"  :clearable="false" name="telephone_country_code" placeholder="" label="isd_code" v-model="form.country_code_telephone" :reduce="option => option.isd_code" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                            <template v-slot:option="option">
                              <span>{{option.isd_code}} - {{option.name}} </span>
                            </template>
                          </v-select>
                          <span class="text-danger text-sm">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                      <div class="vx-col w-2/3">
                        <ValidationProvider vid="site_telephone" name="site_telephone" rules="required|tel|max:15" v-slot="{ errors }">
                          <small class="label">Supplier Telephone</small>
                          <vs-input name="site_telephone"  class="w-full required" label="" v-model="form.telephone" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <div class="vx-row">
                      <div class="vx-col w-1/3">
                        <ValidationProvider vid="fax_country_code" name="fax_country_code" rules="" v-slot="{ errors }">
                          <small class="label">Country Code</small>
                          <v-select :filter-by="myFilter" :clearable="false" name="fax_country_code" placeholder="" label="isd_code" v-model="form.country_code_fax" :reduce="option => option.isd_code" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                            <template v-slot:option="option">
                              <span>{{option.isd_code}} - {{option.name}} </span>
                            </template>
                          </v-select>
                          <span class="text-danger text-sm">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                      <div class="vx-col w-2/3">
                        <ValidationProvider vid="fax" name="fax" rules="" v-slot="{ errors }">
                          <small class="label">Supplier Fax</small>
                          <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" type="text" name="fax" class="w-full" v-model="form.fax" />
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/5 md:mb-0">
                    <ValidationProvider vid="is_vat_registration" name="is_vat_registration" rules="" v-slot="{ errors }">
                      <small class="label">Do you have a Company VAT Registration?</small>
                      <vs-switch v-model="form.is_vat_registration" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                        <span slot="on">Yes</span>
                        <span slot="off">No</span>
                      </vs-switch>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col w-2/5">
                    <ValidationProvider v-if="form.is_vat_registration" vid="is_vat_registration_country" name="is_vat_registration_country" rules="required" v-slot="{ errors }">
                      <small class="label">If Yes, In which country are you registered</small>
                      <v-select :filter-by="myFilter" :clearable="false" name="is_vat_registration_country" placeholder="" label="name" v-model="form.is_vat_registration_country" :reduce="option => option.name" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-2/5 w-full md:mb-0">
                    <ValidationProvider v-if="form.is_vat_registration" vid="is_vat_registration_text" name="is_vat_registration_text" rules="required" v-slot="{ errors }">
                      <small class="label">If Yes, Company VAT Registration</small>
                      <vs-input type="text" name="is_vat_registration_text" class="w-full" v-model="form.is_vat_registration_text"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/5 md:mb-0">
                    <ValidationProvider vid="is_registration" name="is_registration" rules="" v-slot="{ errors }">
                      <small class="label">Do you have a Company Registration Number?</small>
                      <vs-switch v-model="form.is_registration" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                        <span slot="on">Yes</span>
                        <span slot="off">No</span>
                      </vs-switch>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col w-2/5">
                    <ValidationProvider v-if="form.is_registration" vid="is_registration_country" name="is_registration_country" rules="required" v-slot="{ errors }">
                      <small class="label">If Yes, In which country are you registered</small>
                      <v-select :filter-by="myFilter" :clearable="false" name="is_registration_country" placeholder="" label="name" v-model="form.is_registration_country" :reduce="option => option.name" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-2/5 w-full md:mb-0">
                    <ValidationProvider v-if="form.is_registration" vid="is_registration_text" name="is_registration_text" rules="required" v-slot="{ errors }">
                      <small class="label">If Yes, Company Registration Number</small>
                      <vs-input type="text" name="is_registration_text" class="w-full" v-model="form.is_registration_text"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 md:mb-0">
                    <ValidationProvider vid="supplier_status" name="supplier_status" rules="required" v-slot="{ errors }">
                      <small class="label">Supplier Status</small>
                      <v-select  label="name" :closeOnSelect="true" v-model="form.supplier_status" :options="['manufacturer','trader','packer']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider v-if="form.supplier_status === 'trader' ||  form.supplier_status === 'packer'" vid="supplier_identity" name="supplier_identity" rules="required" v-slot="{ errors }">
                      <small class="label">Identity of manufacturer</small>
                      <vs-input type="text" name="supplier_identity" class="w-full" v-model="form.supplier_identity"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
              </vx-card>

              <!-- <vx-card titleColor="#736F6E" title="Contacts" class="my-8">

                <vs-row vs-w="12" class="mt-4">
                  <vs-col v-for="(contact, index) in supplier_contacts" :key="index+'contact'"
                          vs-type="flex"
                          vs-justify="center"
                          vs-align="center"
                          vs-lg="6" vs-sm="6" vs-xs="12"
                          class="px-4 pb-4">
                    <vx-card-custom :cardBorder="true" no-shadow :remove-card-action="!(contact.type === 'emergency' && index === 0)"  v-on:remove="deleteContact(index)" :collapse-action="false">

                      <div class="vx-row mb-2">
                        <div class="vx-col md:w-full w-full md:mb-0">
                          <ValidationProvider :vid="index+'contact_type'" :name="index+'contact_type'" rules="required" v-slot="{ errors }">
                            <small class="label">Contact Type</small>
                            <v-select :disabled="contact.type === 'emergency' && index === 0" label="name" :closeOnSelect="true" v-model="contact.type" :options="['technical','commercial','emergency']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                            <span class="text-danger text-sm">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                      </div>


                      <div class="vx-row mb-2">
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                          <ValidationProvider :vid="index+'contact_name'" :name="index+'contact_name'" rules="required" v-slot="{ errors }">
                            <small class="label">Contact Name</small>
                            <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" name="contact_name" label=""  class="w-full required"  v-model="contact.name"/>
                          </ValidationProvider>
                        </div>
                        <div class="vx-col md:w-1/2 w-full md:mb-0" v-if="contact.type !== 'emergency'">
                          <ValidationProvider :vid="index+'contact_email'" :name="index+'contact_email'" rules="email" v-slot="{ errors }">
                            <small class="label">Contact Email</small>
                            <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" name="contact_email" label=""  class="w-full required"  v-model="contact.email"/>
                          </ValidationProvider>
                        </div>
                        <div class="vx-col md:w-1/2 w-full md:mb-0" v-if="contact.type === 'emergency'">
                          <ValidationProvider :vid="index+'position'" :name="index+'position'" rules="required" v-slot="{ errors }">
                            <small class="label">Contact Position</small>
                            <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" name="contact_position" label=""  class="w-full required"  v-model="contact.position"/>
                          </ValidationProvider>
                        </div>
                      </div>

                      <div class="vx-row mb-2">
                        <div class="vx-col w-2/5">
                          <ValidationProvider :vid="index+'site_telephone_code'" :name="index+'site_telephone_code'" rules="required" v-slot="{ errors }">
                            <small class="label">Country Code</small>
                            <v-select :filter-by="myFilter" :clearable="false"  label="isd_code" v-model="contact.country_code_telephone" :reduce="option => option.isd_code" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                              <template v-slot:option="option">
                                <span>{{option.isd_code}} - {{option.name}} </span>
                              </template>
                            </v-select>
                            <span class="text-danger text-sm">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                        <div class="vx-col w-3/5">
                          <ValidationProvider :vid="index+'site_telephone'" :name="index+'site_telephone'" rules="required|tel|max:15" v-slot="{ errors }">
                            <small class="label">Contact Telephone</small>
                            <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" name="telephone"  class="w-full required" label="" v-model="contact.telephone"/>
                          </ValidationProvider>
                        </div>
                      </div>

                      <div class="vx-row mb-2" v-if="contact.type !== 'emergency'">
                        <div class="vx-col w-2/5">
                          <ValidationProvider :vid="index+'site_country_code_mobile'" :name="index+'site_country_code_mobile'" rules="" v-slot="{ errors }">
                            <small class="label">Country Code</small>
                            <v-select :filter-by="myFilter" :clearable="false"  label="isd_code" v-model="contact.country_code_mobile" :reduce="option => option.isd_code" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                              <template v-slot:option="option">
                                <span>{{option.isd_code}} - {{option.name}} </span>
                              </template>
                            </v-select>
                            <span class="text-danger text-sm">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                        <div class="vx-col w-3/5">
                          <ValidationProvider :vid="index+'site_mobile'" :name="index+'site_mobile'" rules="tel|max:15" v-slot="{ errors }">
                            <small class="label">Contact Mobile</small>
                            <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" name="mobile"  class="w-full required" label="" v-model="contact.mobile"/>
                          </ValidationProvider>
                        </div>
                      </div>

                    </vx-card-custom>
                  </vs-col>
                </vs-row>
                <vs-button class="mt-4 mb-4 ml-4" @click="addNewContact()" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add contact</vs-button>
              </vx-card> -->

              <vx-card class="my-8">
                <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/5 md:mb-0">
                    <ValidationProvider vid="is_product_liability_insurance_cover" name="is_product_liability_insurance_cover" rules="" v-slot="{ errors }">
                      <small class="label">1.1 Do you have Product Liability Insurance Cover? </small>
                      <vs-switch v-model="supplier_additional_detail.is_product_liability_insurance_cover" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                        <span slot="on">Yes</span>
                        <span slot="off">No</span>
                      </vs-switch>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-4/5 w-full md:mb-0">
                    <ValidationProvider v-if="supplier_additional_detail.is_product_liability_insurance_cover" vid="is_product_liability_insurance_cover_text" name="is_product_liability_insurance_cover_text" rules="required" v-slot="{ errors }">
                      <small class="label">If yes, state limit of Liability  (£ GBP)</small>
                      <vs-input type="text" name="is_product_liability_insurance_cover_text" class="w-full" v-model="supplier_additional_detail.is_product_liability_insurance_cover_text"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>

              </vx-card>

              <vx-card class="mt-8">
                <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/5 md:mb-0">
                    <ValidationProvider vid="is_sedex_member" name="is_sedex_member" rules="" v-slot="{ errors }">
                      <small class="label">1.5 Are you members of Sedex?</small>
                      <vs-switch v-model="supplier_additional_detail.is_sedex_member" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                        <span slot="on">Yes</span>
                        <span slot="off">No</span>
                      </vs-switch>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-4/5 w-full md:mb-0" v-if="supplier_additional_detail.is_sedex_member">
                    <ValidationProvider  vid="is_sedex_member_yes" name="is_sedex_member_yes" rules="required" v-slot="{ errors }">
                      <small class="label">If yes, please set up a direct link with ITS (ITS Membership number : ZC1086963)</small>
                      <vs-input type="text" name="is_sedex_member_yes" class="w-full" v-model="supplier_additional_detail.is_sedex_member_yes"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-4/5 w-full md:mb-0"  v-if="!supplier_additional_detail.is_sedex_member">
                    <small class="label">If not, please provide Ethical Policy</small>
                    <file-uploader
                      v-on:onSetFileName="value => supplier_additional_detail.is_sedex_member_file = value"
                      v-on:onClickFileRemove="supplier_additional_detail.is_sedex_member_file = null"
                      :file="supplier_additional_detail.is_sedex_member_file"
                      :condition="true"
                    />
                  </div>
                </div>

                <!-- Save & Reset Button -->
                <div class="flex flex-wrap items-center justify-end">
                  <vs-button v-if="form.status.id !== 3" @click="openApprovalConfirm"
                             class="float-right mt-2 ml-4 hidden" type="border" color="primary">
                    Approve & Save Supplier
                  </vs-button>
                  <vs-button button="submit" class="ml-4 mt-2" >Save Changes</vs-button>
                </div>
              </vx-card>

              <vx-card class="mt-8" :title="`Supplier Portal Status: ${ form.is_supplier_activated === 1 ? 'Active' : 'Inactive' }`"
                  :titleColor="form.is_supplier_activated === 1 ? 'primary' : 'warning'">
                <div class="vx-row mb-3">
                  <span style="display: none">{{form.status.id}}</span>
                  <span style="display: none">{{form.is_supplier_activated}}</span>
                  <vs-button v-if="form.is_supplier_activated === 1" @click="openDeActiveConfirm" class="float-right mt-2 ml-4 " type="border" color="danger">Deactivate Supplier Portal</vs-button>
                  <vs-button v-if="form.is_supplier_activated === 0" @click="openReActiveConfirm" class="float-right mt-2 ml-4" type="border" color="primary">Active Supplier Portal</vs-button>
                </div>
              </vx-card>
            </form>
          </ValidationObserver>
        </vs-tab>
        <vs-tab v-on:click="onClickSageTab()" label="Sage" v-if="$canAny(['view-sage-supplier','create-edit-sage-supplier'])">
          <vx-card id="customer_profile" class="">
            <div v-if="form.sage_id" class="vx-row">
              Sage id: {{ sage_supplier_details.id }} <br>
              Sage ref: {{ sage_supplier_details.reference }} <br>
            </div>

            <!-- Medium -->
            <div class="flex items-center justify-center mb-4">
              <button
                v-if="form.sage_id"
                @click="onClickUnlickSageSupplierVerify()"
                class="cursor-pointer text-primary bg-transparent border-l border-t border-b border-primary hover:bg-primary hover:text-white active:bg-purple-600 font-bold uppercase text-sm px-6 py-3 rounded-l outline-none focus:outline-none mb-1 ease-linear transition-all duration-150"
                type="button">
                Unlink existing supplier
              </button>
              <button
                v-if="!form.sage_id"
                @click="onClickCreateSageSupplier()"
                class="cursor-pointer text-primary bg-transparent border-l border-t border-b border-primary hover:bg-primary hover:text-white active:bg-purple-600 font-bold uppercase text-sm px-6 py-3 rounded-l outline-none focus:outline-none mb-1 ease-linear transition-all duration-150"
                type="button">
                Create new sage supplier
              </button>
              <button
                v-if="!form.sage_id"
                @click="onClickLinkSageSupplier()"
                class="cursor-pointer text-primary bg-transparent border border-solid border-primary hover:bg-primary hover:text-white active:bg-purple-600 font-bold uppercase text-sm px-6 py-3 outline-none focus:outline-none mb-1 ease-linear transition-all duration-150"
                type="button">
                Link to existing supplier
              </button>
              <button
                 id="supplier-sage-sync-button"
                 v-if="form.sage_id"
                 @click="onClickUpdateSageSupplier()"
                 class="cursor-pointer text-primary bg-transparent border border-solid border-primary hover:bg-primary hover:text-white active:bg-purple-600 font-bold uppercase text-sm px-6 py-3 outline-none focus:outline-none mb-1 ease-linear transition-all duration-150"
                 type="button">
                 Synchronise data with sage
               </button>
            </div>
          </vx-card>
        </vs-tab>
      </vs-tabs>
    </div>
    <link-sage-supplier-pop-up ref="linkSageSupplierPopUp"/>
  </div>


</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from 'vue-select'
  const SupplierRepository = RepositoryFactory.get('supplier');
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SageRepository = RepositoryFactory.get('sage')
  import Datepicker from 'vuejs-datepicker';
  import moment from 'moment'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import FileUploader from '@/components/shared/FileUploader'
  import LinkSageSupplierPopUp from "@/components/popups/supplier/sage/LinkSageSupplierPopUp";
  import SageHelper from '@/mixins/SageHelper'
  import { updateSageRmSupplier, createSageRmSupplier } from '@/services/SageService'

  function initialState() {
    return {
      old_password: '',
      countryCodes: [],
      password: '',
      password_confirmation: '',
      company_name: null,
      file: 'sdasd.pdf',
      quantity: null,
      form: {
        is_vat_registration: false,
        is_registration: false,
        is_spray_dry_supplier: false,
        sage_id:'',
        status: {
          id: 1
        }
      },
      supplier_accreditation: {},

      supplier_additional_detail: {
        is_product_liability_insurance_cover: false,
        is_sedex_member: false,
        is_sedex_member_file: ''
      },
      certification_file: null,
      supplier_accreditation_file: null,
      // supplier_contacts: [
      // ],
      supplierId : null,
      formUploadRequired: false,
      formUploadRequiredSedex: false,
      sage_supplier_details: {},
      status_list: [
        { label: 'Approve Supplier', id: '1', value: 'approve', before_status: [ 2, 4 ], color: 'primary' },
        { label: 'Reject Supplier', id: '4', value: 'not-approve', before_status: [ 2 ], color: 'danger' },
        { label: 'Hold / Suspend Supplier', id: '5', value: 'on-hold', before_status: [ 3 ], color: 'warning' },
        { label: 'Re-Instate Supplier', id: '1', value: 're-instate', before_status: [ 5 ], color: 'primary' },
      ]
    }
  }
  export default {
    mixins: [SuccessMessage, ErrorMessages, SageHelper],
    data () {
      return initialState()
    },
    components: {
      'v-select': vSelect,
      Datepicker,
      flatPickr,
      FileUploader,
      LinkSageSupplierPopUp,
    },
    computed: {
    },
    methods: {
      async loadData() {
        this.$vs.loading()
        this.supplierId = this.$route.params.id
        this.countryCodes =  (await SupplierManufactureRepository.getCountryCodes()).data.data

        const {data} = (await SupplierRepository.getBasicSupplierDetails(this.supplierId)).data
        // this.$emit('fetchSupplierData', data)

        if(data.is_complete_details === 1) {
          // this.supplier_contacts =  data.contacts.map((m) => {
          //   let n = {}
          //   n.type = m.type
          //   n.name = m.data.name
          //   n.email = m.data.email
          //   n.telephone = m.data.telephone
          //   n.mobile = m.data.mobile
          //   n.country_code_telephone = m.data.country_code_telephone
          //   n.country_code_mobile = m.data.country_code_mobile
          //   if(m.type === 'emergency') {
          //     n.position = m.data.position
          //   }
          //   return n
          // })
          this.form = data
          this.company_name = data.company_name
          this.supplier_additional_detail = this.form.supplier_additional_detail
          this.form.status = data.status
          this.form.is_supplier_activated = data.is_supplier_activated
        } else {
          // if (data.contacts.length !==0) {
          //   this.supplier_contacts =  data.contacts.map((m) => {
          //     let n = {}
          //     n.type = m.type
          //     n.name = m.data.name
          //     n.email = m.data.email
          //     n.telephone = m.data.telephone
          //     n.mobile = m.data.mobile
          //     n.country_code_telephone = m.data.country_code_telephone
          //     n.country_code_mobile = m.data.country_code_mobile
          //     if(m.type === 'emergency') {
          //       n.position = m.data.position
          //     }
          //     return n
          //   })
          // }
          // this.addNewContact('emergency')
          this.form.company_name = data.company_name
          this.company_name = data.company_name
          this.form.company_name_unique = data.company_name_unique
          this.form.telephone = data.telephone
          this.form.country_code_telephone = data.country_code_telephone
          this.form.status = data.status
          this.form.is_supplier_activated = data.is_supplier_activated
          this.form.sage_id = data.sage_id
        }
        this.$vs.loading.close()
      },
      selectCountry(country){
        let obj = this.countryCodes.find(o => o.name === country);
        this.form.country_code_telephone = obj.isd_code
        this.form.country_code_fax = obj.isd_code
      },
      successUpload(){
        this.$vs.notify({color:'success',title:'Upload Success',text:'Lorem ipsum dolor sit amet, consectetur'})
      },
      // addNewContact: function(type) {
      //   this.supplier_contacts.push(
      //     {type: type ? type : '', name : '', telephone : '', country_code_telephone: ''}
      //   )
      // },
      addNewGfsi: function() {
        this.supplier_GFSIs.push(
          {type: 'GFSI', name: '', grade: '', body: '', description: '', expiry: '', file: '', last_audit: null}
        )
      },
      addNewAccreditations: function() {
        this.supplier_other_accreditations.push(
          {type: 'Other', name: '', grade: '', body: '', description: '', expiry: '', file: '', last_audit: null}
        )
      },
      // deleteContact: function(index) {
      //   this.supplier_contacts.splice(index, 1)
      // },
      deleteGfsi: function(index) {
        this.supplier_GFSIs.splice(index, 1)
      },
      deleteAccreditations: function(index) {
        this.supplier_other_accreditations.splice(index, 1)
      },


      async onClickSupplierProfileUpdate() {
          let payload = this.form
          // payload.supplier_contacts = this.supplier_contacts
          payload.supplier_additional_detail = this.supplier_additional_detail
          this.$vs.loading();
          try {
            const change = await SupplierRepository.updateSupplierBasicDetails(this.supplierId, payload);
            this.showSuccessMessage('Supplier Profile Update Successfully!')
            await this.loadData()
            this.$emit('supplier-updated')
          } catch (e) { 
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
      },
      myFilter: (option, label, search) => {
        let temp = search.toLowerCase();
        return option.name.toLowerCase().indexOf(temp) > -1 ||
          option.isd_code.toLowerCase().indexOf(temp) > -1
      },
      clearFormData() {
        this.password = '';
        this.old_password = '';
        this.password_confirmation = '';
      },
      uploadJanaka() {

      },
      openApprovalConfirm() {
        this.$refs.form.validate().then(async (valid) => {
          if(valid) {
            this.$vs.dialog({
              type: 'confirm',
              color: 'success',
              title: 'Confirm',
              text: 'Are you sure you want to approve this supplier?',
              accept: this.onClickApproveSupplier
            })
          }
        });
      },
      openReActiveConfirm() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'success',
          title: 'Confirm',
          text: 'Are you sure you want to re-active this supplier?',
          accept: this.onClickReActiveSupplier
        })
      },
      openNotApprovalConfirm() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Confirm',
          text: 'Are you sure you want to not approve this supplier?',
          accept: this.onClickNotApproveSupplier
        })
      },
      openDeActiveConfirm() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Confirm',
          text: 'Are you sure you want to de-active this supplier?',
          accept: this.onClickDeActiveSupplier
        })
      },
      supplierStatusChangeConfirmDialog(status) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'warning',
          title: 'Confirm',
          text: 'Are you sure you want to change the status?',
          accept: this.changeSupplierStatus,
          parameters: [status]
        })
      },
      async changeSupplierStatus(params) {
        const vue = this;
        this.$vs.loading();
        try {
          await SupplierRepository.changeSupplierstatus(this.supplierId, params[0])
          this.showSuccessMessage('Supplier status changed successfully');
          await this.loadData()
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close();
      },
      async onClickApproveSupplier() {
        const vue = this;
        this.$vs.loading();
       try {
         let payload = this.form
        //  payload.supplier_contacts = this.supplier_contacts
         payload.supplier_additional_detail = this.supplier_additional_detail
         await SupplierRepository.approveSupplier(this.supplierId, payload)
         this.showSuccessMessage('The selected supplier was successfully approved');
         await this.loadData()
       } catch (e) {
         this.convertAndNotifyError(e)
       }
        this.$vs.loading.close();
      },
      async onClickReActiveSupplier() {
        const vue = this;
        this.$vs.loading();
        try {
          await SupplierRepository.ReActiveSupplier(this.supplierId)
          this.showSuccessMessage('The selected supplier was successfully re-activated');
          this.$router.go(0);
          await this.loadData()
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close();
      },
      async onClickNotApproveSupplier() {
        const vue = this;
        this.$vs.loading();
        try {
          await SupplierRepository.NotApproveSupplier(this.supplierId)
          this.showSuccessMessage('The selected supplier was successfully not approved');
          await this.loadData()
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close();
      },
      async onClickDeActiveSupplier() {
        const vue = this;
        this.$vs.loading();
        try {
          await SupplierRepository.DeActivateSupplier(this.supplierId)
          this.showSuccessMessage('This will  disable access to all users in the supplier. Proceed?');
          this.$router.go(0);
          await this.loadData()
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close();
      },
      async fetchSageSupplierDetails() {
        this.$vs.loading();
        try {
          const { data } = (await SageRepository.getSageSupplierDetails(this.form.sage_id)).data
          this.sage_supplier_details = data
        } catch(e) {
          this.$vs.loading.close()
          this.sageAuthHandler(e.response.status)
        }
        this.$vs.loading.close();
      },
      async onClickCreateSageSupplier() {
        try {
          await createSageRmSupplier(this.form)
          await this.loadData()
          this.showSuccessMessage('Sage supplier created successfully')
        } catch(e) {
          this.sageAuthHandler(e.response.status)
        }
      },
      async onClickUnlickSageSupplierVerify() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Warning',
          acceptText: 'Proceed',
          text: 'You are about to unpair a nimble supplier with Sage. This means that future transactions in sage will not show in this account. Are you sure you wish to proceed?',
          accept: this.onClickUnlickSageSupplier,
          cancel: null
        })
      },
      async onClickUnlickSageSupplier() {
        try{
          await SageRepository.unLinkSageSupplier(this.supplierId, { sage_id: this.form.sage_id })
          this.showSuccessMessage('Sage supplier un-liked successfully')
          await this.loadData()
        } catch (e) {

        }
      },
      async onClickLinkSageSupplier() {
        await this.$refs.linkSageSupplierPopUp.openPopup(this.supplierId, this.form.company_name)
      },
      async onClickSageTab() {
        if(this.form.sage_id) {
          await this.fetchSageSupplierDetails()
        }
      },
      async onClickUpdateSageSupplier() {
        await this.$vs.loading({
          container: '#supplier-sage-sync-button',
          scale: 0.45
        })
        try {
          await updateSageRmSupplier(this.form)
          this.showSuccessMessage('Sage data synchronization successful!')
        } catch (e) {
          this.sageAuthHandler(e.response.status)
        }
        this.$vs.loading.close('#supplier-sage-sync-button > .con-vs-loading')
      },
    },
    async mounted() {
      await this.loadData()
    }
  }
</script>

<style lang="scss">
#customer-profile-tabs {
  width: 100%;
  .vs-tabs--ul {
    display: flex;
  }
  .vs-tabs-position-bottom .vs-tabs--ul, .vs-tabs-position-top .vs-tabs--ul {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-wrap: wrap !important;
    justify-content: space-evenly;
  }

  .vs-tabs--li {
    flex-grow: 1 !important;
  }

  .line-vs-tabs {
    display: none;
  }

  .vs-tabs--li.activeChild {
    border-width: 0 0 2px 0;
    border-color: transparent;
    border-style:solid;
  }
}
</style>
